import React, { Component } from "react";
import { Modal, Button } from "antd";

export default class PrivacyModalBox extends Component {
  render() {
    return (
      <div>
        <div>
          <Modal
            title={false}
            visible={this.props.send}
            footer={false}
            centered
            onOk={this.props.okay}
            onCancel={this.props.cancel}
          >
            <h4 className="spark-dir-heading">
              Spark Directory Privacy Policy
            </h4>
            <p className="spark-dir-para">
              Scouting America maintains the Alumni Spark Directory
              (“Directory”) for the purposes of facilitating interaction with
              Scouting America alumni and allowing alumni to update their records. The
              Directory is user ID and password protected and may be accessed by
              authenticated Scouting America alumni, Scouting America personnel, and other authorized
              users. Each user is responsible for all use of his/her name and
              passwords to gain access to the Directory and for the use of
              information because of such access. Each user acknowledges that
              responsibility and agrees not to share his/her password with any
              other person. Scouting America has taken precautions to secure the personal
              information available through the Directory. However, it is each
              user’s responsibility and decision to what personal/contract
              information he/she wishes to be displayed in the Directory to
              other users. All users may also restrict individual elements of
              profile information by selecting for viewing those fields listed
              in the “My Privacy Settings” frame below. Scouting America’s Privacy Policy
              describes the types of information Scouting America collects, how Scouting America may use
              and disclose such information, and user’s ability to control
              certain uses of it. The Privacy Policy is found at
            </p>
            <a
              href="https://www.scouting.org/legal/privacy-policy/"
              className="policy-link"
              target="_blank"
            >
              https://www.scouting.org/legal/privacy-policy/
            </a>
            <div id="cancel-btn-div">
              <Button id="profile-cancel" onClick={this.props.cancel}>
                Close
              </Button>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Inc/PrivacyModalBox.js